(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("shaka"), require("clappr"));
	else if(typeof define === 'function' && define.amd)
		define(["shaka", "clappr"], factory);
	else if(typeof exports === 'object')
		exports["DashShakaPlayback"] = factory(require("shaka"), require("clappr"));
	else
		root["DashShakaPlayback"] = factory(root["shaka"], root["Clappr"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__254__, __WEBPACK_EXTERNAL_MODULE__502__) => {
return 